// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// TECHNOLOGY STACK SCHEMA
/////////////////////////////////////////

export const TechnologyStackSchema = z.object({
  host: z.string(),
  tech: z.string(),
  version: z.string().nullable(),
  source: z.string().nullable(),
  endpointIds: z.string().array(),
})

export type TechnologyStack = z.infer<typeof TechnologyStackSchema>

export default TechnologyStackSchema;
